import React from 'react';
import {render} from 'react-dom';
import HeaderSection from './Header';
import Footer from '../components/Footer';
import PageHeading from '../components/PageHeading';
import data from './data';
const Card = ({title, email, phone, items}) => (
  <section className="contact-card column large-6 medium-expanded small-12">
    <article className="card-wrapper contact-card__wrapper">
      <header>
        <h3 className="text-center">{title}</h3>
      </header>
      <section>

        <ul className="text-center contact-card__content">
          <i className="footer-card__icon fa fa-map-marker text-center"></i>
          {items.map((item, index) => <li key={index}>{item}</li>)}
        </ul>
        <i className="footer-card__icon fa fa-envelope text-center"></i>
        <span className="text-center">{email}</span>
        <i className="footer-card__icon fa fa-phone text-center"></i>
        {phone.map((item, index) => <span key={index} className="text-center">{item}</span>)}
      </section>
    </article>
  </section>

);

const ContactPage = (props) => {
  return(
    <main className="contact-page">
      <HeaderSection />
      <section>
        <article className="section section-contact-background">
          <PageHeading
            text1='Contact '
            text2='Us '
            text3=''
          />
        </article>
        <article className="row align-spaced">
          <section>
            <h3 className="text-center">FEEDBACK/QUERY</h3>
            <input type="text" name="name" placeholder="Name" className="section-contact__text-input" />
            <input type="text" name="email" placeholder="Email" className="section-contact__text-input" />
            <input type="text" name="subject" placeholder="Subject" className="section-contact__text-input" />
            <input type="text" name="phone" placeholder="Phone No" className="section-contact__text-input" />
            <textarea className= "section-contact__text-area" placeholder="Type your Message here."></textarea>
            <input className="section-contact__button" type="submit" value="Submit" />
          </section>
          <section className="row align-spaced section__content section-contact__background-image">
            {data.map((item, index) =>
             <Card key={index} {...item} />
            )}
          </section>
        </article>
      </section>
      <Footer />
    </main>
  );
};

export default ContactPage;



// WEBPACK FOOTER //
// ./src/ContactPage/index.js